// Register global functions
import getAppInfo from './getAppInfo'

(window as any).getAppInfo = () => getAppInfo()
